import './page/hueb-seo-category';
import './page/hueb-seo-article';
import './page/hueb-seo-category-tree';
//import './page/hueb-seo-conversion';

/*import './component/hueb-seo-conversion-404';*/
import './component/hueb-seo-robots';
import './component/hueb-seo-rich';
/*import './component/hueb-seo-conversion-socialmedia';
import './component/hueb-seo-conversion-newsletter';
import './component/hueb-seo-conversion-header';
import './component/hueb-seo-conversion-rich';*/
import './component/hueb-seo-canonical';

import './hueb-seo.scss';

import deDE from './snippet/de-DE.json';
import enGB from './snippet/en-GB.json';

const { Module } = Shopware;

Module.register('hueb-seo', {
    type: 'plugin',
    name: 'HuebSEOUltimate',
    title: 'hueb-seo.general.mainMenuItemGeneral',
    description: 'hueb-seo.general.descriptionTextModule',
    color: '#ff7f00',
    icon: 'default-basic-shape-star',
    backgroundEnabled: false,

    snippets: {
        'de-DE': deDE,
        'en-GB': enGB
    },

    routes: {
        category: {
            component: 'hueb-seo-category',
            path: 'category',
        },
        article: {
            component: 'hueb-seo-article',
            path: 'article',
        },
        /*conversion: {
            component: 'hueb-seo-conversion',
            path: 'conversion',
        }*/
    },

    navigation: [
        {
            name: 'hueb-seo-article',
            parent: 'sw-marketing',
            path: 'hueb.seo.article',
            label: 'hueb-seo.general.labelSettingsArticle',
            backgroundEnabled: false,
            position: 90
        }, {
            name: 'hueb-seo-category',
            parent: 'sw-marketing',
            path: 'hueb.seo.category',
            label: 'hueb-seo.general.labelSettingsCategory',
            backgroundEnabled: false,
            position: 91
        }, /*{
            name: 'hueb-seo-conversion',
            parent: 'sw-marketing',
            path: 'hueb.seo.conversion',
            label: 'hueb-seo.general.labelSettingsConversion',
            backgroundEnabled: false,
            iconComponent: 'huebert-seo-icon',
            position: 92
        }*/]
});
